const actionTypes = {
  INFO_LOADING: Symbol('INFO_LOADING'),
  FETCH_HOTEL_LIST: Symbol('FETCH_HOTEL_LIST'),
  TOGGLE_HOTEL_MODAL_VISIBLE: Symbol('TOGGLE_HOTEL_MODAL_VISIBLE'),
  SAVE_CURRENT_HOTEL: Symbol('SAVE_CURRENT_HOTEL'),
  HOTEL_DETAIL_LOADING: Symbol('HOTEL_DETAIL_LOADING'),
  FETCH_HOTEL_DETAIL: Symbol('FETCH_HOTEL_DETAIL'),
  FTECH_CITY_LIST: Symbol('FTECH_CITY_LIST'),
  FETCH_AREA_LIST: Symbol('FETCH_AREA_LIST'),
  SAVE_COMMON_CODE: Symbol('SAVE_COMMON_CODE'),
  FETCH_CURR_ALBUM_LIST: Symbol('FETCH_CURR_ALBUM_LIST'),
  UPDATE_CURR_ALBUM_INFO: Symbol('UPDATE_CURR_ALBUM_INFO'),
  FETCH_HOTEL_BASE_INFO: Symbol('FETCH_HOTEL_BASE_INFO'),
  SET_HOTEL_BASE_INFO: Symbol('SET_HOTEL_BASE_INFO'),
  FETCH_SHOP_INFOS: Symbol('FETCH_SHOP_INFOS'),
  UPDATE_CURR_ALBUM_SORT: Symbol('UPDATE_CURR_ALBUM_SORT'),
  FETCH_HOTEL_FACILITIES: Symbol('FETCH_HOTEL_FACILITIES'),
  FETCH_HOTEL_BABLE_LIST: Symbol('FETCH_HOTEL_BABLE_LIST'),
  SET_HOTEL_RULE_LIST: Symbol('SET_HOTEL_RULE_LIST'),
  INFO_STATUS: Symbol('INFO_STATUS'),
  UPDATE_ROOM_TYPE_INFO: Symbol('UPDATE_ROOM_TYPE_INFO'),
  SET_HOTEL_FACILITIES: Symbol('SET_HOTEL_FACILITIES'),
  SET_IS_APPROVE_OPEN: Symbol('SET_IS_APPROVE_OPEN'),
  SET_IS_APPROVE_SUCCESS_OPEN: Symbol('SET_IS_APPROVE_SUCCESS_OPEN'),
  FETCH_APPROVE_INFO: Symbol('FETCH_APPROVE_INFO'),
  APPROVE_INFO_LOADING: Symbol('APPROVE_INFO_LOADING'),
  FETCH_EXPOSED_LABEL_LIST: Symbol('FETCH_EXPOSED_LABEL_LIST'),
};

export default actionTypes;
